import { creditCardOptions } from '../utils/creditCardOptions';

export function getCreditCardType(cur_val) {
  if (cur_val) {
    // get rid of anything but numbers
    cur_val = cur_val.replace(/\D/g, '');
    let sel_brand = 'Unknown';
    creditCardOptions.forEach((option) => {
      // checks per each, as their could be multiple hits
      //fix: ordering matter in detection, otherwise can give false results in rare cases

      if (cur_val.match(option.regex)) {
        sel_brand = option.value;
      }
      if (cur_val[0] === '5') {
        //started 5 must be mastercard
        sel_brand = 'MasterCard';
      }
    });
    return sel_brand;
  }
}
